import React from 'react';
import Loading from 'components/pure/utils/Loading';
import CardReasonList from './CardReasonList';
import CardReasonFormDialog from './CardReasonFormDialog';
import Button from '@material-ui/core/Button';

export default class CardReasonPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.createNewScheme = this.createNewScheme.bind(this);
    this.editScheme = this.editScheme.bind(this);

    this.state = {showEditDialog: false, isCreateNew: undefined};
  }

  createNewScheme() {
    this.props.CardReasonEditActions.initializeForm();
    this.setState({showEditDialog: true, isCreateNew: true});
  }

  editScheme(cardReasonSchemeId) {
    this.props.CardReasonEditActions.initializeForm();
    this.props.CardReasonEditActions.fetchCardReasonScheme(cardReasonSchemeId);
    this.setState({showEditDialog: true, isCreateNew: false});
  }

  render() {
    const {wasError, isLoading, cardReasonsInfo} = this.props.CardReasonStore;
    const {showEditDialog, isCreateNew} = this.state;

    return (
      <div className="scorecard-reason-schemes-page">
        <h1>Scorecard Reasons Schemes</h1>
        <p>You can create and edit scorecard reason schemes from this screen.</p>

        <p>
          <Button
            variant="contained"
            color="primary"
            className="ev-button"
            onClick={this.createNewScheme}>
            New Scorecard Reason Scheme
          </Button>
        </p>

        {wasError ? (
          'Error fetching profiles.'
        ) : isLoading ? (
          <Loading />
        ) : (
          <CardReasonList reasons={cardReasonsInfo} openCardReasonEditForm={this.editScheme} />
        )}
        {showEditDialog && (
          <CardReasonFormDialog
            editStore={this.props.CardReasonEditStore}
            editActions={this.props.CardReasonEditActions}
            onRequestClose={() => this.setState({showEditDialog: false, isCreateNew: undefined})}
            allowChoosingReasonScheme={isCreateNew}
          />
        )}
      </div>
    );
  }
}
